import { themr } from '@friendsofreactjs/react-css-themr';
import SnackbarComponent from './Snackbar';
import SnackbarsWrapperComponent from './SnackbarsWrapper';

const Snackbar = themr('Snackbars')(SnackbarComponent);
export const SnackbarsWrapper = themr('Snackbars')(SnackbarsWrapperComponent);

export default Snackbar;
